module.exports = __webpack_public_path__ + "img/head-side.45a14666.svg";